import  Accordion from 'react-bootstrap/Accordion'
import { Card } from 'react-bootstrap-v5'
import TablePassedCalls from './TablePassedCalls'

interface Props {
  callHistory: any[],
  activityHistNumber: number,
  setActivityHistNumber: any
}

const ModalPassedCalls:React.FC<Props> = ({callHistory, activityHistNumber, setActivityHistNumber}) => {

  return (

  
    <Accordion >
      <Accordion.Item eventKey="0" >
        <Accordion.Header ><strong>Geçmiş Aramalar</strong></Accordion.Header>
        <Accordion.Body className='bg-secondary'>
        <Card.Body >
           <TablePassedCalls callHistory={callHistory}/>
           <div className='d-flex justify-content-between w-100'>
            <button className='btn p-1 float-right color-warning text-success border border-success mt-5' onClick={() => setActivityHistNumber(5)}>Daha Az Göster</button>
            <button className='btn p-1 float-right color-warning text-primary border border-primary mt-5' onClick={() => setActivityHistNumber(activityHistNumber + 5)}>Daha Fazla Göster</button>
           </div>
        </Card.Body>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>





    // <div>

    //     <Accordion>
    //     <Accordion.Toggle as={Card.Header} eventKey='0' className='fs-6 fw-bolder bg-secondary'>
    //      <div className="row justify-content-between">
    //       <div className="col-6">Geçmiş Aramalar</div>
    //       <div className="col-6 text-end"><KTSVG
    //                       path='/media/icons/duotone/Navigation/Angle-down.svg'
    //                       className='svg-icon-2'
    //                     /></div>
    //      </div>
    //     </Accordion.Toggle>

    //     <Accordion.Collapse eventKey='0' className='bg-secondary'>
    //       <Card.Body>
    //         <TablePassedCalls />
    //       </Card.Body>
    //     </Accordion.Collapse>
    //   </Accordion>
      
    // </div>
  )
}

export default ModalPassedCalls
